import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { horizontalBarChart, barChart } from '../../../../components/charts/index'
import { barChartData, barChartOptions, horizontalChartData, horizontalChartOptions } from './chartConfig'
import { mapState } from 'vuex';
import { ISession } from '../../../../types';

interface IStatistics {
  domainName: string;
  placingsLegend: null;
  placingsLabels: null;
  placingsCurrents: number[];
  placingsOverall: number[];
  changesLegend: null;
  changesLabels: null;
  changesCurrents: number[];
  changesOverall: number[];
  totalGrowth: number;
  labels: {[key: string]: string};
  }

@Component({
  components: {
    horizontalBarChart,
    barChart,
  },
  computed: mapState({

    ServiceId: (state: {session: ISession}) => state.session.serviceId
  })
})

export default class Statistics extends Vue {

  private namespace: string = '/Keywords';

  private ServiceId!: number;

  private statistics: IStatistics | null = null;

  private error: boolean = false;

  private get BarChartData () {

    if (this.statistics != null) {

      let chartData = {...barChartData};
      
      chartData.labels = [this.$tc('keywords.statistics.directions', 1) as string, this.$tc('keywords.statistics.directions', 2) as string];
      
      chartData.datasets[0].data = this.statistics.changesCurrents;
      chartData.datasets[0].label = this.$tc('overview.serpbook.th4', 2) as string;
      chartData.datasets[1].data = this.statistics.changesOverall;
      chartData.datasets[1].label = this.$t('overview.serpbook.th5') as string;

      return chartData;
    }
    
    return barChartData;
  }

  private get BarChartOptions () {

    if (this.statistics != null) {

      let chartOptions = {...barChartOptions};

      chartOptions.scales.yAxes[0].scaleLabel.labelString = this.$t('keywords.rankings.title') as string;

      return chartOptions;
    }

    return barChartOptions;
  }

  private get HorizontalChartData () {

    if (this.statistics != null) {

      let chartData = {...horizontalChartData};

      chartData.datasets[0].data = this.statistics.placingsCurrents;
      chartData.datasets[0].label = this.$t('keywords.statistics.current') as string;
      chartData.datasets[1].data = this.statistics.placingsOverall;
      chartData.datasets[1].label = this.$t('overview.serpbook.th5') as string;

      return chartData;
    }

    return horizontalChartData;
  }

  private get HorizontalChartOptions () {

    if (this.statistics != null) {
     
      let chartOptions = {...horizontalChartOptions};

      chartOptions.scales.xAxes[0].scaleLabel.labelString = this.$t('keywords.statistics.numkeywords') as string;
      chartOptions.scales.yAxes[0].scaleLabel.labelString = this.$t('keywords.rankings.title') as string;

      return chartOptions;
    }

    return horizontalChartOptions;
  }

  mounted () {

    if ( this.ServiceId != null) {

      this.getData();
    }
  }

  private async getData () {
    
    try {
      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/Statistics`, { params: { serviceId: this.ServiceId } })

      this.statistics = response.data;
    } catch(err) {
        
      this.error = !this.error;
    }
  }

  @Watch('ServiceId')
  private loadDomain (next: number, prev: number) {

    if (next != prev) {

      this.statistics = null;
      this.getData();
    }
  }
}